export default __webpack_public_path__ + "static/media/Shadow's Helm of the Nadir.d77bf9d6.jpg";